import request from "@/utils/request";

export default function editShipments(params) {
    return request({
        url: `/shopCar/agency/editShipments`,
        method: 'post',
        data: params
    })
}
